import { rpc } from "src/composables/Rpc";
import { Guid } from "src/interfaces/InleagueApiV1";

export const getGameScheduleCompDivPairs = rpc<void, {validPairs: {competitionUID: Guid, divID: Guid}[]}>("get", "v1/game/getGameScheduleCompDivMenu");
